function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1968(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 23.54,
    height: 9.12,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.0133333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.77,
    y: 4.56,
    fontFamily: "Arial"
  }, "\n        Menominee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.12,
    width: 23.54,
    height: 20.94,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.77,
    y: 19.59,
    fontFamily: "Arial"
  }, "\n        Florence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 30.06,
    width: 23.54,
    height: 36.82,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.708
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.77,
    y: 48.47,
    fontFamily: "Arial"
  }, "\n        Pepin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 66.88,
    width: 23.54,
    height: 38.81,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9233333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.77,
    y: 86.285,
    fontFamily: "Arial"
  }, "\n        Forest\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 105.69,
    width: 23.54,
    height: 40.86,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.885
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.77,
    y: 126.12,
    fontFamily: "Arial"
  }, "\n        Iron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 146.55,
    width: 23.54,
    height: 46.52,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.708
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.77,
    y: 169.81,
    fontFamily: "Arial"
  }, "\n        Adams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 193.06,
    width: 23.54,
    height: 47.85,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6155555555555554
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.77,
    y: 216.985,
    fontFamily: "Arial"
  }, "\n        Marquette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 240.91,
    width: 23.54,
    height: 55.32,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3628571428571425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.77,
    y: 268.57,
    fontFamily: "Arial"
  }, "\n        Burnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 296.22,
    width: 23.54,
    height: 58.47,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9233333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.77,
    y: 325.45500000000004,
    fontFamily: "Arial"
  }, "\n        Sawyer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 354.7,
    width: 23.54,
    height: 62.75,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.9425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.77,
    y: 386.075,
    fontFamily: "Arial"
  }, "\n        Washburn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 417.44,
    width: 23.54,
    height: 68.02,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3628571428571425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.77,
    y: 451.45,
    fontFamily: "Arial"
  }, "\n        Buffalo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 485.47,
    width: 23.54,
    height: 70.28,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.9425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.77,
    y: 520.61,
    fontFamily: "Arial"
  }, "\n        Bayfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 555.75,
    width: 23.54,
    height: 70.81,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.708
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.77,
    y: 591.155,
    fontFamily: "Arial"
  }, "\n        Vilas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 626.55,
    width: 23.54,
    height: 73.45,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.885
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.77,
    y: 663.275,
    fontFamily: "Arial"
  }, "\n        Rusk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.54,
    y: 0,
    width: 37.14,
    height: 46.86,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.305714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.11,
    y: 23.43,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.67,
    y: 0,
    width: 37.95,
    height: 46.86,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.74375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.64500000000001,
    y: 23.43,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.63,
    y: 0,
    width: 39.67,
    height: 46.86,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.95875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.465,
    y: 23.43,
    fontFamily: "Arial"
  }, "\n        Waushara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.29,
    y: 0,
    width: 40.4,
    height: 46.86,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.08
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 158.48999999999998,
    y: 23.43,
    fontFamily: "Arial"
  }, "\n        Price\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.69,
    y: 0,
    width: 42.85,
    height: 46.86,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.35625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 200.115,
    y: 23.43,
    fontFamily: "Arial"
  }, "\n        Richland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.55,
    y: 0,
    width: 42.85,
    height: 46.86,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.141666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 242.97500000000002,
    y: 23.43,
    fontFamily: "Arial"
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264.4,
    y: 0,
    width: 44.22,
    height: 46.86,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 286.51,
    y: 23.43,
    fontFamily: "Arial"
  }, "\n        Juneau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 308.62,
    y: 0,
    width: 44.3,
    height: 46.86,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.328571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 330.77,
    y: 23.43,
    fontFamily: "Arial"
  }, "\n        Ashland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 352.91,
    y: 0,
    width: 45.89,
    height: 46.86,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.098888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 375.855,
    y: 23.43,
    fontFamily: "Arial"
  }, "\n        Lafayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 398.8,
    y: 0,
    width: 45.89,
    height: 46.86,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.4725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 421.745,
    y: 23.43,
    fontFamily: "Arial"
  }, "\n        Iowa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 444.69,
    y: 0,
    width: 46.48,
    height: 46.86,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 467.93,
    y: 23.43,
    fontFamily: "Arial"
  }, "\n        Langlade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 491.17,
    y: 0,
    width: 47.56,
    height: 46.86,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.686
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 514.95,
    y: 23.43,
    fontFamily: "Arial"
  }, "\n        Green_Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 538.74,
    y: 0,
    width: 48.3,
    height: 46.86,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.8575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 562.89,
    y: 23.43,
    fontFamily: "Arial"
  }, "\n        Kewaunee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 587.04,
    y: 0,
    width: 55.2,
    height: 46.86,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 614.64,
    y: 23.43,
    fontFamily: "Arial"
  }, "\n        Door\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 642.24,
    y: 0,
    width: 57.76,
    height: 46.86,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.694285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 671.12,
    y: 23.43,
    fontFamily: "Arial"
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.54,
    y: 46.86,
    width: 58.56,
    height: 47.5,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.318181818181818
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.82,
    y: 70.61,
    fontFamily: "Arial"
  }, "\n        Trempealeau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.54,
    y: 94.36,
    width: 58.56,
    height: 50.54,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.22
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.82,
    y: 119.63,
    fontFamily: "Arial"
  }, "\n        Calumet\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.54,
    y: 144.9,
    width: 58.56,
    height: 50.7,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.450000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.82,
    y: 170.25,
    fontFamily: "Arial"
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.54,
    y: 195.6,
    width: 58.56,
    height: 51.81,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.635
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.82,
    y: 221.505,
    fontFamily: "Arial"
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.54,
    y: 247.41,
    width: 58.56,
    height: 52.14,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.035
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.82,
    y: 273.48,
    fontFamily: "Arial"
  }, "\n        Dunn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.54,
    y: 299.55,
    width: 58.56,
    height: 52.29,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.82,
    y: 325.695,
    fontFamily: "Arial"
  }, "\n        Vernon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.54,
    y: 351.84,
    width: 58.56,
    height: 52.36,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.726666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.82,
    y: 378.02,
    fontFamily: "Arial"
  }, "\n        Oconto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.54,
    y: 404.2,
    width: 58.56,
    height: 52.78,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.556000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.82,
    y: 430.59,
    fontFamily: "Arial"
  }, "\n        Green\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.54,
    y: 456.98,
    width: 58.56,
    height: 56.69,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.1725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.82,
    y: 485.32500000000005,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.54,
    y: 513.66,
    width: 58.56,
    height: 59.52,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.76
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.82,
    y: 543.42,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.54,
    y: 573.19,
    width: 58.56,
    height: 61.2,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.712
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.82,
    y: 603.7900000000001,
    fontFamily: "Arial"
  }, "\n        Clark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.54,
    y: 634.39,
    width: 58.56,
    height: 65.61,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.365714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.82,
    y: 667.1949999999999,
    fontFamily: "Arial"
  }, "\n        Shawano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.09,
    y: 46.86,
    width: 59.31,
    height: 66.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.885
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.745,
    y: 80.09,
    fontFamily: "Arial"
  }, "\n        Barron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.4,
    y: 46.86,
    width: 61.75,
    height: 66.46,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.861111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.275,
    y: 80.09,
    fontFamily: "Arial"
  }, "\n        St._Croix\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.15,
    y: 46.86,
    width: 64.55,
    height: 66.46,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.172222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.425,
    y: 80.09,
    fontFamily: "Arial"
  }, "\n        Marinette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.7,
    y: 46.86,
    width: 68.95,
    height: 66.46,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.494285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 302.175,
    y: 80.09,
    fontFamily: "Arial"
  }, "\n        Waupaca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 336.65,
    y: 46.86,
    width: 70.04,
    height: 66.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.615
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 371.66999999999996,
    y: 80.09,
    fontFamily: "Arial"
  }, "\n        Sauk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406.7,
    y: 46.86,
    width: 71.59,
    height: 66.46,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.3075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 442.495,
    y: 80.09,
    fontFamily: "Arial"
  }, "\n        Chippewa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 478.29,
    y: 46.86,
    width: 71.64,
    height: 66.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.3075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 514.11,
    y: 80.09,
    fontFamily: "Arial"
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 549.93,
    y: 46.86,
    width: 74.72,
    height: 66.46,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.494285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 587.29,
    y: 80.09,
    fontFamily: "Arial"
  }, "\n        Portage\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 624.65,
    y: 46.86,
    width: 75.35,
    height: 66.46,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.291999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 662.3249999999999,
    y: 80.09,
    fontFamily: "Arial"
  }, "\n        Grant\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.09,
    y: 113.32,
    width: 78.81,
    height: 70.36,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.051428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.495,
    y: 148.5,
    fontFamily: "Arial"
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.09,
    y: 183.68,
    width: 78.81,
    height: 77,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.495,
    y: 222.18,
    fontFamily: "Arial"
  }, "\n        Ozaukee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.09,
    y: 260.67,
    width: 78.81,
    height: 83.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.881
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.495,
    y: 302.32,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.09,
    y: 343.97,
    width: 78.81,
    height: 83.55,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.756666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.495,
    y: 385.745,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.09,
    y: 427.52,
    width: 78.81,
    height: 89.5,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.85125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.495,
    y: 472.27,
    fontFamily: "Arial"
  }, "\n        Walworth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.09,
    y: 517.02,
    width: 78.81,
    height: 89.91,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.7025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.495,
    y: 561.975,
    fontFamily: "Arial"
  }, "\n        Wood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.09,
    y: 606.92,
    width: 78.81,
    height: 93.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.881
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.495,
    y: 653.4599999999999,
    fontFamily: "Arial"
  }, "\n        Eau_Claire\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.9,
    y: 113.32,
    width: 87.63,
    height: 85.27,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.054
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 204.715,
    y: 155.95499999999998,
    fontFamily: "Arial"
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.53,
    y: 113.32,
    width: 104.3,
    height: 85.27,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.474444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 300.68,
    y: 155.95499999999998,
    fontFamily: "Arial"
  }, "\n        Manitowoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 352.83,
    y: 113.32,
    width: 106.36,
    height: 85.27,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.474444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 406.01,
    y: 155.95499999999998,
    fontFamily: "Arial"
  }, "\n        La_Crosse\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 459.19,
    y: 113.32,
    width: 111.27,
    height: 85.27,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.751818181818181
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 514.825,
    y: 155.95499999999998,
    fontFamily: "Arial"
  }, "\n        Fond_du_Lac\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 570.46,
    y: 113.32,
    width: 129.54,
    height: 85.27,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.65875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 635.23,
    y: 155.95499999999998,
    fontFamily: "Arial"
  }, "\n        Marathon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.9,
    y: 198.59,
    width: 99,
    height: 116.03,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 210.4,
    y: 256.605,
    fontFamily: "Arial"
  }, "\n        Sheboygan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.9,
    y: 314.62,
    width: 99,
    height: 123.43,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.142857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 210.4,
    y: 376.33500000000004,
    fontFamily: "Arial"
  }, "\n        Kenosha\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.9,
    y: 438.05,
    width: 99,
    height: 123.94,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 210.4,
    y: 500.02,
    fontFamily: "Arial"
  }, "\n        Outagamie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.9,
    y: 561.99,
    width: 99,
    height: 138.01,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 210.4,
    y: 630.995,
    fontFamily: "Arial"
  }, "\n        Winnebago\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.9,
    y: 198.59,
    width: 129.48,
    height: 110.88,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 27.72
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 324.64,
    y: 254.03,
    fontFamily: "Arial"
  }, "\n        Rock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 389.39,
    y: 198.59,
    width: 146.88,
    height: 110.88,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.176
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 462.83,
    y: 254.03,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 536.26,
    y: 198.59,
    width: 163.74,
    height: 110.88,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.48
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 618.13,
    y: 254.03,
    fontFamily: "Arial"
  }, "\n        Racine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.9,
    y: 309.47,
    width: 141.55,
    height: 177.28,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.69375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 330.67499999999995,
    y: 398.11,
    fontFamily: "Arial"
  }, "\n        Waukesha\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.9,
    y: 486.74,
    width: 141.55,
    height: 213.26,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 35.3875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 330.67499999999995,
    y: 593.37,
    fontFamily: "Arial"
  }, "\n        Dane\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 401.45,
    y: 309.47,
    width: 298.55,
    height: 390.53,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 33.172222222222224
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 550.725,
    y: 504.735,
    fontFamily: "Arial"
  }, "\n        Milwaukee\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1968);
export default __webpack_public_path__ + "static/media/1968.68c3bc13102855ff2d7173efa1b878e3.svg";
export { ForwardRef as ReactComponent };